import React from 'react';
import ScanPlay from '@uber/base-icons/scan-play';
type PropsT = {
  size?: number;
  strokeColor?: string;
};
export function FrameClassification({
  size = 16,
  strokeColor
}: PropsT) {
  return <ScanPlay size={size} color={strokeColor} />;
}